module.exports = {
  ConfigData : {
  "APP_ID": "dual-broker-reg",  
  "API_URL": " https://apim-dual-services-integration-layer-prod-ne01.azure-api.net/broker-registration/SendEmail",
  "OCP_APIM_SUBSCRIPTION_KEY": "b84bad42278b4865be0e3c885a81bdfa"
  }
}